/// <reference path="../../types.d.ts" />
import { cmxReducerFactory } from '../reducer-utils';
import * as JsonView from '../../actions/json-view';
import * as UIActions from '../../actions/ui';
import { setActiveProcess } from '../../actions/json-view';

export const InitialState = {
  activeItem: null,
  activeCaseRun: {} as CMxAPI.CaseRun,
  loading: true,
  locked: false
};

const reducer = cmxReducerFactory<CMx.CaseJSONState>(InitialState)
  .case(JsonView.onLoad.async.done, (state, { result }) => {
    const { caseDetail, activeProcess } = result;
    return {
      ...state,
      activeItem: caseDetail,
      activeCaseRun: activeProcess,
      loading: false
    };
  })
  .case(UIActions.parentDidNavigate, (state, didNavigate) => {
    return { ...state, locked: !didNavigate };
  })
  .case(setActiveProcess, (state, newActiveCaseRun) => {
    return {
      ...state,
      activeCaseRun: newActiveCaseRun
    };
  });

export default reducer;
